import { Button, Flex, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { MdFeedback } from 'react-icons/md';
import FeedbackModal from './FeedbackModal';

const FeedbackButton: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        onClick={onOpen}
        w="full"
        h="44px"
        px="14px"
        justifyContent="flex-start"
        iconSpacing="10px"
        color="white"
        fontSize="sm"
        fontWeight={600}
        letterSpacing="0.01em"
        borderRadius="14px"
        bgGradient="linear(135deg, brand.500, brand.400)"
        boxShadow="0 6px 16px -8px rgba(0, 0, 0, 0.35)"
        transition="transform 0.16s ease, box-shadow 0.16s ease"
        _hover={{
          bgGradient: 'linear(135deg, brand.500, brand.400)',
          transform: 'translateY(-1px)',
          boxShadow: '0 10px 22px -8px rgba(0, 0, 0, 0.45)',
        }}
        _active={{ transform: 'translateY(0)' }}
        sx={{
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:hover': { transform: 'none' },
          },
        }}
        leftIcon={
          <Flex
            align="center"
            justify="center"
            boxSize="26px"
            borderRadius="full"
            bg="whiteAlpha.300"
          >
            <MdFeedback size={15} />
          </Flex>
        }
      >
        Enviar feedback
      </Button>
      <FeedbackModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default FeedbackButton;
